<template>
  <vs-popup
    id="variantPriceModal"
    :active.sync="isActiveLocal"
    title="Varyant Fiyat İşlemleri"
    v-esc="escape"
  >
    <vs-row vs-type="flex" vs-w="12" v-if="localVariant">
      <vs-row vs-type="flex" vs-w="12">
        <span class="text-primary text-small weight-600">
          {{ localVariant.name }}
        </span>
      </vs-row>
      <vs-divider></vs-divider>
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
              <span class="text-primary text-smaller weight-600 w-full">
                Alış Fiyatı
              </span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-input
            id="buyPrice"
            name="Varyant Alış Fiyatı"
            v-validate="{
                  required: true,
                  regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                }"
            v-model="localVariant.buyPrice"
            class="w-full"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Varyant Alış Fiyatı')">
                {{ errors.first("Varyant Alış Fiyatı") }}
              </span>
        </vs-row>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col vs-type="block" vs-w="6" class="pr-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12">
              <span class="text-primary text-smaller weight-600 w-full">
                Alış Fiyatı Birimi
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-align="top">
              <v-select
                id="buyPriceUnit"
                :disabled="alternateUnits.length == 0"
                @input="setConvertedBuyPrice"
                name="Alış Fiyatı Birimi"
                v-validate="'required'"
                class="w-full"
                v-model="localVariant.buyPriceUnit"
                itemid="id"
                label="name"
                placeholder="Alış Fiyatı Birimi Seçimi.."
                :options="alternateUnits"
                :clearable="false"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Alış Fiyatı Birimi')">
                {{ errors.first(".Alış Fiyatı Birimi") }}
              </span>
            </vs-row>
          </vs-row>
        </vs-col>
        <vs-col vs-type="block" vs-w="6" class="pl-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12">
              <span class="text-primary text-smaller weight-600 w-full">
                Sipariş Birimi
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12">
              <v-select
                id="orderUnit"
                :disabled="alternateUnits.length == 0"
                name="Sipariş Birimi"
                v-validate="'required'"
                class="w-full"
                v-model="localVariant.orderUnit"
                itemid="id"
                label="name"
                placeholder="Sipariş Birimi Seçimi.."
                :options="alternateUnits"
                :clearable="false">
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Sipariş Birimi')">
                {{ errors.first("Sipariş Birimi") }}
              </span>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-divider></vs-divider>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
          <vs-button
            class="mr-auto"
            type="gradient"
            color="danger"
            @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
          <vs-button color="success" @click="saveVariant">Kaydet
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import {getConvertedBuyPrice} from "@/api/RawMaterial";

export default {
  name: "VariantPriceModal",
  data() {
    return {
      localVariant: null
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.escape();
        }
      },
    },
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    variant: {
      type: Object,
      required: false,
    },
    alternateUnits: {
      type: Array,
      required: false
    }
  },
  methods: {
    escape() {
      this.$emit("close");
    },
    setConvertedBuyPrice() {
      if (!this.variant.id || this.variant.id == 0) return;
      getConvertedBuyPrice(this.variant.buyPriceUnit.id, this.variant.id).then(res => {
        if (res && res.status == 200) {
          this.localVariant.buyPrice = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "ALış Fiyatı Çevirilemedi !",
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası",
        });
      });
    },
    saveVariant() {
      this.$emit("saveVariant", this.localVariant)
      this.escape();
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.localVariant = _.cloneDeep(this.variant);
      } else {
        this.localVariant = null
      }
    }
  }
};
</script>

<style>
#variantPriceModal .vs__dropdown-menu {
  position: static!important;
}
</style>
